import { CartConditionsErrorType } from 'src/lib/utils/automationsHelpers'
import { CatalogueDataType } from './catalogue'
import { FlowErrorType } from './error'

export enum CartConditionOptions {
  NO_CONDITIONS = 'NO_CONDITIONS',
  PURCHASE_AMOUNT = 'PURCHASE_AMOUNT',
  PURCHASE_QUANTITY = 'PURCHASE_QUANTITY'
}

export enum PurchaseOptions {
  ENTIRE_CART = 'ENTIRE_CART',
  SPECIFIC_PRODUCTS = 'SPECIFIC_PRODUCTS',
  SPECIFIC_COLLECTIONS = 'SPECIFIC_COLLECTIONS'
}

export type QuantityDistributorBlockType = {
  minimumValue: number
  maximumValue: number | null
  applicationType: CartConditionOptions.PURCHASE_AMOUNT | CartConditionOptions.PURCHASE_QUANTITY
  catalogueMetadata: CatalogueDataType[]
}

export interface ProductQuantityDistributorBlockType extends QuantityDistributorBlockType {
  catalogType: PurchaseOptions.SPECIFIC_PRODUCTS
  productIds: string[]
  variantIds: string[]
}

export interface CollectionQuantityDistributorBlockType extends QuantityDistributorBlockType {
  catalogType: PurchaseOptions.SPECIFIC_COLLECTIONS
  collectionIds: string[]
}

export type QuantityDistributorType =
  | {
      type: PurchaseOptions.SPECIFIC_PRODUCTS
      quantityDistributionItems: ProductQuantityDistributorBlockType[]
    }
  | {
      type: PurchaseOptions.SPECIFIC_COLLECTIONS
      quantityDistributionItems: CollectionQuantityDistributorBlockType[]
    }

export type CartConditionStateType =
  | {
      type: CartConditionOptions.NO_CONDITIONS
    }
  | {
      type: CartConditionOptions.PURCHASE_AMOUNT | CartConditionOptions.PURCHASE_QUANTITY
      selectedOption:
        | {
            type: PurchaseOptions.ENTIRE_CART
            minimumValue: number
            maximumValue: number | null
          }
        | {
            type: PurchaseOptions.SPECIFIC_PRODUCTS
            quantityDistribution: QuantityDistributorType
          }
        | {
            type: PurchaseOptions.SPECIFIC_COLLECTIONS
            quantityDistribution: QuantityDistributorType
          }
    }

export type QuantityDistributorErrorStateType = {
  minimumValue: FlowErrorType
  maximumValue: FlowErrorType
  selectedItems: FlowErrorType
}
export type CartConditionErrorStateType = {
  minimumValue: FlowErrorType
  maximumValue: FlowErrorType
}

export type PopoverType = 'AMOUNT' | 'QUANTITY' | 'NONE'

export interface CartConditionV2Props {
  state: CartConditionStateType
  setState: (state: CartConditionStateType) => void
  errors?: CartConditionsErrorType
  config?: {
    showAllProducts?: boolean
  }
}
